// extracted by mini-css-extract-plugin
module.exports = {"Container":"NavigationItems_Container__3WfLu","Logo":"NavigationItems_Logo__2d7Fv","NavigationItems":"NavigationItems_NavigationItems__3eu8l","Icon":"NavigationItems_Icon__3SYE4"};